/**
 * Breadcrumb-origin `from` param writer. The readers, matcher tables, and fresh-tab gate live in
 * `webserver/assets/react/utils/breadcrumbOrigin.ts`, which re-exports this writer.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BREADCRUMB_FROM_LABEL_PARAM () {
        return BREADCRUMB_FROM_LABEL_PARAM;
    },
    get BREADCRUMB_FROM_PARAM () {
        return BREADCRUMB_FROM_PARAM;
    },
    get appendCurrentLocationAsFrom () {
        return appendCurrentLocationAsFrom;
    }
});
const BREADCRUMB_FROM_PARAM = "from";
const BREADCRUMB_FROM_LABEL_PARAM = "fromLabel";
const appendCurrentLocationAsFrom = (href, label)=>{
    const origin = typeof window !== "undefined" ? window.location.pathname + window.location.search : "";
    if (!origin) return href;
    const separator = href.includes("?") ? "&" : "?";
    let result = `${href}${separator}${BREADCRUMB_FROM_PARAM}=${encodeURIComponent(origin)}`;
    if (label) result += `&${BREADCRUMB_FROM_LABEL_PARAM}=${encodeURIComponent(label)}`;
    return result;
};
